import * as Redux from 'redux';
import { Router } from 'react-router';
import * as LogRocket from 'logrocket';

export function authenticate(
  store: Redux.Store<RootState>,
  replace: Function
): boolean {
  const nextLocation = window.location.pathname;
  const reduxState = store.getState();
  if (reduxState.users.token) {
    if (
      window.location.hostname == 'dashing.sourcesage.co' ||
      window.location.hostname == 'dashboard.sourcesage.co'
    ) {
      //Only for dashing and dashboard
      //If user is authenticated, send identity to LogRocket
      LogRocket.identify('' + reduxState.users.user.id, {
        name: reduxState.users.user.full_name,
        email: reduxState.users.user.email,
      });
    }

    return true;
  }

  if (nextLocation) {
    replace(
      `/login?redirect=${encodeURIComponent(nextLocation)}&lang=${
        reduxState.i18n.locale
      }`
    );
    return false;
  }
  replace(`/login?lang=${reduxState.i18n.locale}`);
  return false;
}

export const requireAuthOnEnter = (store: Redux.Store<RootState>) => {
  return (nextState: Router.RouterState, replace: Function) => {
    authenticate(store, replace);
  };
};

export function requireAuthOnChange(store: Redux.Store<RootState>) {
  return (
    prevState: Router.RouterState,
    nextState: Router.RouterState,
    replace: Function
  ) => {
    authenticate(store, replace);
  };
}

/*
  const requireAdmin = (store: Redux.Store<RootState>) => {
    const { admin } = store.getState().users.user;
    const isAdmin = admin;
    return (nextState: RootState, replace: Function) => isAdmin || replace('/');
  };
  */

export const requireStaff = (store: Redux.Store<RootState>) => (
  nextState: Router.RouterState,
  replace: Function
) => store.getState().users.user.staff || replace('/');

/*
   * `getComponent` from react-router asynchronously loads the component.
   */
export const makeGetComponent = (modulePath: string) => (
  location: any,
  callback: Function
) =>
  require.ensure([], require =>
    callback(null, require<any>(`../containers/${modulePath}`).default)
  );



// WEBPACK FOOTER //
// ./app/routers/utils.ts